import { render, staticRenderFns } from "./DeleteDynamicListDialog.vue?vue&type=template&id=ef14d58a"
import script from "./DeleteDynamicListDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteDynamicListDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports